import { withIcon } from './withIcon';

const ArrowFromBoxSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.77257 3.91388C4.50469 3.64599 4.50469 3.2117 4.77257 2.94381L7.51543 0.200917C7.78331 -0.0669723 8.2176 -0.0669723 8.48549 0.200917L11.2283 2.94381C11.4962 3.2117 11.4962 3.64599 11.2283 3.91388C11.0949 4.04737 10.9193 4.11503 10.7438 4.11503C10.5682 4.11503 10.3927 4.04828 10.2592 3.91388L8.68663 2.34129V10.7428C8.68663 11.1213 8.37943 11.4285 8.00091 11.4285C7.6224 11.4285 7.3152 11.1213 7.3152 10.7428V2.3422L5.74263 3.91479C5.47474 4.18268 5.04046 4.18177 4.77257 3.91388ZM15.3143 10.058C14.9358 10.058 14.6286 10.3652 14.6286 10.7437V13.4866C14.6286 14.1165 14.1157 14.6294 13.4857 14.6294H2.51429C1.88434 14.6294 1.37143 14.1165 1.37143 13.4866V10.7437C1.37143 10.3652 1.06423 10.058 0.685714 10.058C0.3072 10.058 0 10.3652 0 10.7437V13.4866C0 14.8736 1.12731 16.0009 2.51429 16.0009H13.4857C14.8727 16.0009 16 14.8736 16 13.4866V10.7437C16 10.3652 15.6928 10.058 15.3143 10.058Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowFromBox = withIcon(ArrowFromBoxSvg);
